import React, { useEffect, useRef, useState } from "react";
import {
  Avatar,
  Box,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Textfield from "../../../../common/Textfield";
import { UploadIcon } from "../../../../assets/constants";
import HeaderText from "../../../../common/HeaderText";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { makeStyles } from "@mui/styles";
import Style from "../../style";
import axios from "axios";
import { fileTypes, formatSizeUnits } from "../../../../utils/helpers";
import AlertMessage from "../../../../common/AlertMessage";
import { LoadingButton } from "@mui/lab";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  getCaseClientDocsFunc,
  getCaseDetailByCaseId,
} from "../../../../actions/Cases";
import { getAgencyDetailFunc } from "../../../../actions/Agency";
import {
  segmentError,
  segmentTrack,
} from "../../../../utils/helpers/tracking_utils";
import { innerFolderViewFunc } from "../../../../actions/DocumentsActions";
import { appInsights } from "../../../../utils/helpers/AppInsights";

const Styles = makeStyles((theme) => Style(theme));

const UploadDocManually = ({
  agent,
  case_obj,
  client,
  onClose,
  setOpen,
  getCaseDocuments,
  selectedDocument,
}) => {
  const classes = Styles();
  const [files, setFiles] = useState([]);
  const [documentType, setDocumentType] = useState("personal");
  const [formData, setFormData] = useState(new FormData());
  // const [uploadedFiles, setUploadedFiles] = useState([]);
  const [showProgress, setShowProgress] = useState(false);
  //  const [error, setError] = useState(null);
  const [status, setStatus] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  const [alertOpen, setAlertOpen] = useState(false);

  const dispatch = useDispatch();
  const caseDetailByCaseId = useSelector((state) => state.caseDetailByCaseId);
  const {
    loading: loadingCaseDetail,
    error: errorCaseDetail,
    caseDetail,
  } = caseDetailByCaseId;

  const agentProfile = useSelector((state) => state.agentProfile);
  const { loading: loadingAgent, error: errorAgent, agentUser } = agentProfile;

  const getAgencyDetail = useSelector((state) => state.getAgencyDetail);
  const {
    loading: loadingAgency,
    error: errorAgency,
    agencyDetail,
  } = getAgencyDetail;

  useEffect(() => {
    dispatch(getAgencyDetailFunc());
  }, []);

  const handleAlertClick = () => {
    setAlertOpen(true);
  };

  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setAlertOpen(false);
  };

  const fileInputRef = useRef(null);

  // var userInfo = localStorage.getItem("userInfo");
  const [token, setToken] = useState("");
  const agentToken = Cookies.get("token");
  // const cookieAgentId = Cookies.get("agentId");
  // const cookieAgencyId = Cookies.get("agencyId");

  useEffect(() => {
    // if (userInfo) {
    //   userInfo = JSON.parse(userInfo);
    //   setToken(userInfo.token);
    // }

    if (agentToken) {
      setToken(agentToken);
      // setAgentID(cookieAgentId);
      // setAgencyID(cookieAgencyId);
    }
  }, [token]);

  const handleClickFile = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const localFormData = new FormData();
    const localFiles = Array.from(e.target.files);
    formData.forEach((value, key) => {
      localFormData.append(key, value);
    });

    for (let i = 0; i < localFiles.length; i++) {
      localFormData.append("files", localFiles[i]);
    }

    setFiles((prevState) => [...prevState, ...localFiles]);
    setFormData(localFormData);
  };

  // useEffect(() => {
  //   dispatch(getCaseDetailByCaseId());
  //   // getCaseDetailByCaseId
  // }, []);

  const submitDocumentHandler = async (e) => {
    e.preventDefault();

    if (!files.length) {
      setStatus({
        type: "error",
        message: "Please upload atleast one file!",
      });
      handleAlertClick();
      return;
    }

    setLoading(true);
    try {
      const config = {
        headers: {
          "Content-type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      };

      let res;
      const doc_type = "case_level";

      if (selectedDocument) {
        formData.set("client_id", client?.id);
        formData.set("case_id", case_obj?.id);
        formData.set("folder_id", selectedDocument?.id);
        formData.set("file_type", selectedDocument?.folder_type);
        // formData.set("title", documentName);

        res = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/storage/upload-files`,
          formData,
          config
        );
      } else {
        formData.set("client_id", client?.id);
        formData.set("case_id", case_obj?.id);
        formData.set("file_type", doc_type);
        formData.set("folder_id", case_obj?.client?.root_folder_id);

        res = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/storage/upload-files`,
          formData,
          config
        );
      }

      if (!res?.data?.ok) {
        appInsights.trackTrace({
          message: `Error while uploading documents in case: ${
            res?.data?.message || "Uploading documents failed in case!"
          }`,
        });
        segmentError({
          event: "ERR_BACKEND_UPLOADING_CASE_DOCUMENTS",
          agent: agentUser?.agent,
          agency: agencyDetail?.agency,
          error: `${
            res?.data?.message || "Error while uploading documents in case!"
          } `,
        });
        setStatus({
          type: "error",
          message: res?.data?.message,
        });
        handleAlertClick();
        setLoading(false);

        return;
      }

      setStatus({
        type: "success",
        message: `Files uploaded!`,
      });
      handleAlertClick();
      setLoading(false);
      setFiles([]);
      if (selectedDocument) {
        dispatch(innerFolderViewFunc(client?.id, selectedDocument?.id));
        dispatch(getCaseClientDocsFunc(case_obj?.id, client?.id));
      } else {
        dispatch(getCaseDetailByCaseId(case_obj?.id));
      }

      setFormData(new FormData());
      onClose("right", false);
      setOpen(false);

      if (agentUser?.agent && agencyDetail?.agency) {
        segmentTrack({
          event: "document_uploaded",
          agent: agentUser?.agent,
          agency: agencyDetail?.agency,
        });
      }
    } catch (error) {
      appInsights.trackTrace({
        message: `Error while uploading documents in case: ${
          error || "Uploading documents failed in case!"
        }`,
      });
      segmentError({
        event: "ERR_BACKEND_UPLOADING_CASE_DOCUMENTS",
        agent: agentUser?.agent,
        agency: agencyDetail?.agency,
        error: `${
          error || "Error while uploading documents manually in case!"
        } `,
      });
      console.log(error);
      setStatus({
        type: "error",
        message:
          error.data && error.data.message ? error.data.message : error.message,
      });
      setLoading(false);
      onClose("right", false);
      setOpen(false);
    }
  };

  const deleteFileHandler = (idx, file) => {
    const names = formData.getAll("files");
    formData.delete("files");

    names
      .filter((name) => name.name !== file?.name)
      .forEach((name) => formData.append("files", name));

    setFiles(files.filter((_, i) => i !== idx));
  };

  return (
    <>
      {!loading && (status?.type === "success" || status?.type === "error") && (
        <AlertMessage
          message={status?.message}
          severity={status?.type}
          open={alertOpen}
          handleClose={handleAlertClose}
        />
      )}

      <Stack
        gap="24px"
        component="form"
        onSubmit={submitDocumentHandler}
        noValidate
        height="100%"
      >
        <Stack gap={3} flex="1">
          {/* <Typography
            variant="boxHeading"
            color="secondary"
            textTransform="uppercase"
          >
            Document Name
          </Typography>
          <Textfield
            name="documentName"
            value={documentName}
            onChange={(e) => setDocumentName(e.target.value)}
            label="Name"
            variant="outlined"
            readOnly={selectedDocument}
            required
          /> */}
          {/* <TextField
            variant="outlined"
            value={documentType}
            onChange={(e) => setDocumentType(e.target.value)}
            fullWidth
            select
            label="Type"
            InputProps={selectedDocument ? { readOnly: true } : {}}
          >
            <MenuItem value="personal">Personal</MenuItem>
            <MenuItem value={case_obj?.id}>{case_obj?.title}</MenuItem>
          </TextField> */}

          {/* <Stack>
            <Typography
              variant="boxHeading"
              color="secondary"
              textTransform="uppercase"
            >
              Upload Documents
            </Typography>
            <HeaderText
              variant="body1"
              color="secondary"
              fontSize="12px"
              fontWeight="400"
              textAlign="-webkit-auto"
              textContent="All files will be grouped under Client agreement."
            />
          </Stack> */}

          <Stack
            alignItems="center"
            justifyContent="center"
            gap="10px"
            sx={{ cursor: "pointer" }}
            border="1px dashed #566875"
            p="10px"
            height="301px"
            borderRadius="8px"
            onClick={handleClickFile}
          >
            <input
              type="file"
              style={{ display: "none" }}
              name="file"
              ref={fileInputRef}
              multiple
              onChange={handleFileChange}
              required
            />
            <UploadIcon />
            <HeaderText
              textContent="Select files"
              color="#000"
              variant="h6"
              fontSize="16px"
              fontWeight="400"
            />
            <Typography
              variant="h6"
              fontSize="14px"
              fontWeight="400"
              color="secondary"
            >
              Click{" "}
              <span style={{ color: "#0C80F3", textDecoration: "underline" }}>
                browse
              </span>{" "}
              through your computer
            </Typography>
          </Stack>

          <Stack gap="8px" pb="50px">
            {files?.map((file, i) => (
              <Box
                padding="12px"
                display="flex"
                alignItems="flex-start"
                bgcolor="#FCFCFC"
                gap="8px"
                key={i}
              >
                <Box
                  width="48px"
                  height="48px"
                  bgcolor="#fff"
                  borderRadius="8px"
                  padding="2px"
                >
                  <Avatar
                    src={fileTypes(file?.type)}
                    alt="client"
                    className={classes.icon}
                    variant="rounded"
                  />
                </Box>
                <Stack width="100%" gap="8px">
                  <Stack>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <HeaderText
                        textContent={file?.name}
                        fontSize="16px"
                        fontWeight="400"
                        color="#000"
                      />
                      <IconButton
                        size="small"
                        onClick={() => deleteFileHandler(i, file)}
                      >
                        <CancelOutlinedIcon />
                      </IconButton>
                    </Box>
                  </Stack>
                  <HeaderText
                    textContent={formatSizeUnits(file.size)}
                    fontSize="12px"
                    fontWeight="400"
                    variant="body1"
                    textAlign="-webkit-auto"
                  />
                </Stack>
              </Box>
            ))}
          </Stack>
        </Stack>

        <Stack alignItems="flex-end" py={2}>
          <LoadingButton
            variant="contained"
            disabled={!files.length > 0}
            type="submit"
            loading={loading}
          >
            Upload Documents
          </LoadingButton>
        </Stack>
      </Stack>
    </>
  );
};

export default UploadDocManually;
